import { Breadcrumb } from "antd";
import React, { useMemo } from "react";
import ButtonWrapper from "../../../components/reuseComp/ButtonWrapper";
import { useMessageApi } from "../../../../provider/AntdNotification";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ITeamPayloadAndResponse } from "../../../../types/api/team";
import { useTeamDelete, useTeamList } from "../../../../hooks/api/team/hooks";
import TeamTable from "./TeamTable";
import TeamForm from "./TeamForm";

const MainTeamComp: React.FC<{ allowURLStateUpdate?: boolean }> = ({
  allowURLStateUpdate = true,
}) => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const isCreatePage = location.pathname === "/website/team/create";
  const isEditPage = !!id;

  const message = useMessageApi();
  const DEFAULT_NUQS_CONFIG = {
    throttleMs: !allowURLStateUpdate ? Infinity : 0,
  };

  const {
    data,
    refetchWithQuery: refetch,
    isFetching,
  } = useTeamList({
    page: 1,
    limit: 20,
    ...DEFAULT_NUQS_CONFIG,
  });

  const teamList: ITeamPayloadAndResponse[] = useMemo(
    () => data?.data || [],
    [data]
  );

  const qData = data?.qData ?? { page: 1, limit: 20 };
  const { mutate: deleteService } = useTeamDelete({ qData });

  const handleDelete = (id: string) => {
    deleteService(
      { ids: id },
      {
        onSuccess: () => {
          message.success("Team deleted successfully");
        },
        onError: (err: any) => {
          const msg =
            err?.response?.data?.message ||
            err?.message ||
            "Failed to delete Team";

          message.error(msg);
        },
      }
    );
  };

  return (
    <div className="mb-6">
      <div className=" flex justify-between items-center">
        <h1 className="text-xl sm:text-3xl  sm:mb-2">
          {isCreatePage
            ? "add Team"
            : isEditPage
            ? "Edit Team"
            : "Teams"}
        </h1>
        {!isCreatePage && !isEditPage && (
          <ButtonWrapper
            className="bg-primary text-white"
            onClick={() => navigate("/website/team/create")}
          >
            Create Team
          </ButtonWrapper>
        )}
      </div>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "Dashboard", href: "/" }, { title: "Teams" }]}
        />
      </div>
      <div>
        {isCreatePage || isEditPage ? (
          <TeamForm qData={qData} id={id} />
        ) : (
          <TeamTable
            {...{
             data: teamList,
              refetch,
              qData,
              DEFAULT_NUQS_CONFIG,
              loading: isFetching,
              handleDelete,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default MainTeamComp;
